/**
 * Class set on document.body while an overlay should hide Tidio (#tidio may mount
 * after first paint; CSS in ListingPage.module.css mirrors this).
 * Keep in sync with the :global(body....) rule there.
 */
export const TIDIO_HIDDEN_FOR_OVERLAY_BODY_CLASS = 'neokasa-hide-tidio';

/**
 * Opens the Tidio widget (script in public/index.html).
 * Safe if the script is still loading.
 */
export function openTidioChat() {
  if (typeof window === 'undefined') return;

  if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
    window.tidioChatApi.open();
    return;
  }

  const onReady = () => {
    document.removeEventListener('tidioChat-ready', onReady);
    if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
      window.tidioChatApi.open();
    }
  };
  document.addEventListener('tidioChat-ready', onReady, { once: true });
}

/**
 * Hides the Tidio widget (API + body class fallback for late iframe mount).
 */
export function hideTidioChat() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  document.body.classList.add(TIDIO_HIDDEN_FOR_OVERLAY_BODY_CLASS);

  if (window.tidioChatApi && typeof window.tidioChatApi.hide === 'function') {
    window.tidioChatApi.hide();
    return;
  }

  const onReady = () => {
    document.removeEventListener('tidioChat-ready', onReady);
    if (window.tidioChatApi && typeof window.tidioChatApi.hide === 'function') {
      window.tidioChatApi.hide();
    }
  };
  document.addEventListener('tidioChat-ready', onReady, { once: true });
}

/**
 * Shows the Tidio widget again (unless cookie consent UI is open — see public/index.html).
 */
export function showTidioChat() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  document.body.classList.remove(TIDIO_HIDDEN_FOR_OVERLAY_BODY_CLASS);

  if (window.__cookieConsentUIOpen) {
    return;
  }

  if (window.tidioChatApi && typeof window.tidioChatApi.show === 'function') {
    window.tidioChatApi.show();
    return;
  }

  const onReady = () => {
    document.removeEventListener('tidioChat-ready', onReady);
    if (window.__cookieConsentUIOpen) {
      return;
    }
    if (window.tidioChatApi && typeof window.tidioChatApi.show === 'function') {
      window.tidioChatApi.show();
    }
  };
  document.addEventListener('tidioChat-ready', onReady, { once: true });
}
